import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'

export function ThemeToggle() {
  const { setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')
  }

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" disabled aria-label={m.toggleTheme()}>
        <div className="size-4" />
      </Button>
    )
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={m.toggleTheme()}
      className="relative"
    >
      <Sun className="absolute size-4 rotate-0 scale-100 text-slate-700 dark:text-slate-100 transition-transform dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute size-4 rotate-90 scale-0 text-slate-700 dark:text-slate-100 transition-transform dark:rotate-0 dark:scale-100" />
      <span className="sr-only">{m.toggleTheme()}</span>
    </Button>
  )
}
